import React, { useEffect } from "react";
import styles from "./modal.module.css";

export const Modal = ({
  show,
  onClose,
  children,
  isClosable = true,
  overlayStyle = {},
  contentStyles = {},
  contentClassName = "",
  withHeader = false,
  headerTitle = "Add Title",
  titleClassNames = "",
  titleStyles = {},
  closeOnEscape = true,
  closeButtonClassName = " btn btn-sm btn-outline-secondary",
}) => {
  useEffect(() => {
    if (closeOnEscape && show) {
      const handleEscape = (e) => {
        if (e.key === "Escape") {
          onClose();
        }
      };

      window.addEventListener("keydown", handleEscape);

      return () => {
        window.removeEventListener("keydown", handleEscape);
      };
    }
  }, [show, closeOnEscape, onClose]);

  if (!show) return null;

  return (
    <div
      className={`${styles.modal_overlay}`}
      onClick={isClosable ? onClose : null}
      style={overlayStyle}
    >
      <div
        className={`${styles.modal_content} ${contentClassName} border shadow-lg`}
        onClick={(e) => e.stopPropagation()}
        style={contentStyles}
      >
        {withHeader && (
          <div className="w-100 d-flex justify-content-between align-items-center mb-3">
            <div
              className={`font-weight-bold ${styles.modal_title} ${titleClassNames}`}
              style={{
                ...titleStyles,
                whiteSpace: "normal",
                wordBreak: "break-word",
              }}
            >
              {headerTitle}
            </div>
          </div>
        )}
        {children}

        {isClosable && (
          <div
            className="position-absolute"
            style={{ top: "20px", right: "20px" }}
          >
            <button className={`${closeButtonClassName}`} onClick={onClose}>
              <i className="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
